import React, { useCallback, useEffect, useState } from "react";
import { AiOutlinePlus } from "react-icons/ai";

import { IoArrowBackOutline } from "react-icons/io5";
import { ERROR_MSG } from "../../../constants/common";
import { SET_ERROR } from "../../../constants/contexConstant";
import { GET_TICKET_BY_PLANT_ENDPOINT } from "../../../constants/routes";
import { useContextState } from "../../../context/ContextProvider";
import useFileUploadAndRemove from "../../../hooks/useFileUploadAndRemove";
import cn from "../../../lib/cn";
import { check } from "../../../resources/js/images";
import request from "../../../services/request";
import Container from "../../../shared/Container";
import P from "../../../shared/typography/P";
import Button from "../../../shared/ui/Button";
import BottomDrawer from "../../../shared/ui/Drawer/BottomDrawer";
import Confirmation from "../sections/Confirmation";
import PopupMeta from "./PopupMeta";
import SupportMessage from "./SupportMessage";
import WrapperMessageView from "./WrapperMessageView";

const ChatContainer = ({ meta, feedbackMeta }) => {
    const { state, dispatch } = useContextState();

    const [showModal, setShowModal] = useState(false);

    const [loading, setLoading] = useState(false);

    const [ticketList, setTicketList] = useState([]);
    const [showConfirmation, setShowConfirmation] = useState(null);

    useEffect(() => {
        const loadAllTicketList = async () => {
            try {
                setLoading(true);
                let res = await request.authGet({
                    endpoint: `${GET_TICKET_BY_PLANT_ENDPOINT}/${state?.user?.plant?.plantId}`,
                });
                setTicketList(res.data?.tickets);
                setLoading(false);
            } catch (error) {
                setLoading(false);

                dispatch({
                    type: SET_ERROR,
                    payload: typeof error === "string" ? error : ERROR_MSG,
                });
            }
        };
        loadAllTicketList();
    }, [dispatch, state?.user?.plant?.plantId]);

    const pushLatestQueryHandler = useCallback(
        (newQuery) => {
            setTicketList([newQuery, ...ticketList]);
            setShowConfirmation(newQuery);
        },
        [ticketList]
    );

    const [activeChat, setActiveChat] = useState(null);
    const [showBack, setShowBack] = useState(false);
    const [showRating, setShowRating] = useState(false);
    const [currentMessage, setCurrentMessage] = useState("");

    const {
        file,
        setFile,
        uploadedDoc,
        uploading,
        setUploadedDoc,
        handleFileChange,
        removeFile,
    } = useFileUploadAndRemove();

    const handleActiveChat = () => {
        setFile([]);
        setActiveChat(null);
        setUploadedDoc([]);
        setCurrentMessage("");
        setShowRating(false);
        setShowBack(false);
    };

    const metaList = meta?.data?.tickets?.HyperSrot;
    return (
        <>
            <div className="rounded-sm pt-4 lg:pt-0 mb-4 lg:mb-0  shadow-md lg:shadow-none lg:border lg:border-blue-60 lg:max-h-[90vh]">
                <div className="  box-border rounded-sm ">
                    <div className="flex justify-between items-center bg-white px-1.6  mb-1 lg:mb-2.4 py-0.4 rounded lg:rounded-sm">
                        {activeChat ? (
                            <button
                                onClick={handleActiveChat}
                                className={cn(
                                    "text-base items-center gap-0.5 mb-1 mx-1.2 pt-0.2",
                                    {
                                        "flex opacity ": activeChat,
                                        hidden: !activeChat,
                                    }
                                )}
                            >
                                <IoArrowBackOutline /> Go Back
                            </button>
                        ) : (
                            <P className="text-gray-370">Support tickets</P>
                        )}

                        {metaList && (
                            // && checkIsAllowed(state?.user?.roles, [
                            //         ROLE.CONSUMER_OWNER,
                            //         ROLE.INVESTOR,
                            //     ] )
                            <div className="my-1.6 lg:my-2 min-w-[150px]">
                                <Button
                                    onClick={() => setShowModal(true)}
                                    className=" flex items-center text-sm md:text-sm lg:text-sm xl:text-sm 2xl:text-sm font-normal rounded-full px-1.5  lg:rounded-0.7 xl:rounded-0.7 py-0.7 lg:py-0.8 xl:py-0.8 "
                                >
                                    <AiOutlinePlus /> Raise New Query
                                </Button>
                            </div>
                        )}
                    </div>
                    {!ticketList.length ? (
                        <SupportMessage />
                    ) : (
                        <WrapperMessageView
                            key={showBack}
                            activeChat={activeChat}
                            setActiveChat={setActiveChat}
                            setShowBack={setShowBack}
                            meta={metaList}
                            feedbackMeta={feedbackMeta}
                            ticketList={ticketList}
                            setTicketList={setTicketList}
                            setFile={setFile}
                            setUploadedDoc={setUploadedDoc}
                            currentMessage={currentMessage}
                            setCurrentMessage={setCurrentMessage}
                            showRating={showRating}
                            file={file}
                            uploading={uploading}
                            uploadedDoc={uploadedDoc}
                            removeFile={removeFile}
                            handleFileChange={handleFileChange}
                            setShowRating={setShowRating}
                        />
                    )}
                </div>
            </div>

            <PopupMeta
                isOpen={showModal}
                onClose={() => setShowModal(false)}
                meta={metaList || null}
                onCreate={pushLatestQueryHandler}
            />
            <BottomDrawer
                isOpen={showConfirmation}
                onClick={() => setShowConfirmation(null)}
                contentClass="bg-white"
            >
                <div className="">
                    <Container className="pb-6.4 ">
                        <Confirmation
                            img={check}
                            heading={
                                <>
                                    Support Ticket Request{" "}
                                    <span className="font-vietnam text-blue">
                                        #{showConfirmation?.id}
                                    </span>
                                </>
                            }
                            message="We have recorded your request and will share update with in 24 hours"
                        >
                            <div className="flex justify-center w-full mt-4">
                                <P className="text-gray-120 text-xs">
                                    Note: You can track support ticket request
                                    status under section Profile / Support
                                </P>
                            </div>
                        </Confirmation>
                    </Container>
                </div>
            </BottomDrawer>
        </>
    );
};

export default ChatContainer;
